(function() {
    const refreshInterval = 10000;

    class ActiveCampaignsService {
        watchers = [];

        constructor(
            APIService,
            $timeout
        ) {
            this.APIService = APIService;
            this.$timeout = $timeout;
        }

        watchTemplate(campaignTemplateId) {
            return this._storeWatcher(
                new ActiveCampaignWatcher(
                    this.APIService,
                    this.$timeout,
                    campaignTemplateId
                )
            );
        }

        stopAllWatchers() {
            const watchers = this.watchers.splice(
                0,
                this.watchers.length
            );
            if (!watchers.length) {
                return;
            }
            for (const watcher of watchers) {
                try {
                    watcher.stop();
                } catch (e) {
                    console.warn(`Unable to stop watcher:`, e);
                }
            }
        }

        /**
         * @param {ActiveCampaignWatcher} watcher
         * @private
         * @returns {ActiveCampaignWatcher}
         */
        _storeWatcher(watcher) {
            this.watchers.push(watcher);
            return watcher;
        }
    }

    /**
     * @typedef ActiveCampaignsCallback
     */

    class ActiveCampaignWatcher {
        /**
         * @type {((isActive: boolean) => void)[]}
         */
        callbackFunctions = [];
        $timeoutPromise;
        /**
         * @type {Number}
         */
        campaignTemplateId;

        constructor(
            APIService,
            $timeout,
            campaignTemplateId
        ) {
            this.APIService = APIService;
            this.$timeout = $timeout;
            this.campaignTemplateId = campaignTemplateId;
            this.refreshAndScheduleNextRefresh = () => {
                this.refresh()
                    .then(() =>
                        this.$timeoutPromise = this.$timeout(
                            this.refreshAndScheduleNextRefresh,
                            refreshInterval
                        )
                    );
            };
        }

        start() {
            return this.stop()
                .refresh()
                .then(() => {
                    this.$timeoutPromise = this.$timeout(
                        this.refreshAndScheduleNextRefresh,
                        refreshInterval
                    );
                });
        }

        stop() {
            if (this.$timeoutPromise) {
                this.$timeout.cancel(this.$timeoutPromise);
            }
            return this;
        }

        /**
         * @param {(isActive: boolean) => void} [callback]
         */
        subscribe(callback) {
            this.callbackFunctions.push(callback);
            this.start();
            return this;
        }

        /**
         * @param {(isActive: boolean) => void} [callback]
         */
        unsubscribe(callback) {
            if (callback) {
                const index = this.callbackFunctions.indexOf(callback);
                if (index === -1) {
                    throw new Error("subscription callback not registered");
                }
                this.callbackFunctions.splice(index, 1);
            } else {
                this.callbackFunctions.splice(
                    0,
                    this.callbackFunctions.length
                );
            }
            return this;
        }

        refresh() {
            return this.APIService.Campaigns.isCampaignTemplateCurrentlyActive(
                this.campaignTemplateId
            ).then(result => {

                for (const fn of this.callbackFunctions) {
                    try {
                        fn(result.data);
                    } catch (e) {
                        console.error(
                            "active campaigns callback errors",
                            e
                        );
                    }
                }
            }).catch(err => {
                console.log("unable to refresh campaign activity", err);
            });
        }
    }

    angular.module("dashboard")
        .service("ActiveCampaignsService", [
            "APIService",
            "$timeout",
            ActiveCampaignsService
        ]);

    if (typeof module !== "undefined") {
        module.exports = {
            ActiveCampaignsService,
            ActiveCampaignWatcher,
            refreshInterval
        }
    }
})();
